import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid, Modal } from '@mui/material';
import moment from 'moment';
import SingleSelectAdd from './SingleSelectAdd';
import { generateEmptyQuestion, validate } from '../utils';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import service from '../../../apis/service';
import { showProgress } from '../../../redux/actions/DealershipActions';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import useFetchData from '../hooks/useFetchData';
import ShowProgress from '../../ui/Backdrop';
import CustomPopupFooter from '../../shared/CustomPopupFooter';
import CustomPopupTopBar from '../../shared/CustomPopupTopBar';

const modalStyle = {
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '1013px',
  maxHeight: '96vh',
  backgroundColor: '#F2F4F7',
  boxShadow: 24,
};

const useStyle = makeStyles({
  headerConatiner: {
    width: '100%',
    height: '72px',
    padding: '24px 16px',
    background: 'white',
  },
  contentContainer: {
    flex: 1,
    overflowY: 'auto',
    padding: '16px',
    backgroundColor: '#F2F4F7',
  },
  buttonContainer: {
    background: '#FFFFFF',
    height: '64px',
    borderTop: '1px solid #E0E0E0',
    padding: '0 16px',
  },
});

const AddQuiz = ({ quizId = null, handleClose, isOpen, seriesId }) => {
  const dispatch = useDispatch();
  const details = useSelector((state) => state?.getQuiz?.quizDetails);
  const classes = useStyle();
  const [data, setData] = useState({
    publishDate: moment().add(1, 'days').format('YYYY-MM-DD'),
    seriesId,
    passingPercentage: 60,
    numberOfQuestions: 1,
    questions: [generateEmptyQuestion()],
  });

  const { fetchQuizDetails, fetchQuizSeriesList } = useFetchData();

  useEffect(() => {
    if (quizId) {
      fetchQuizDetails(quizId);
    }
  }, [fetchQuizDetails, quizId]);

  useEffect(() => {
    if (details && quizId) {
      const cleanedQuestions = details.questions.map((q) => ({
        ...q,
        options: q.options.map((opt) => ({ ...opt })),
      }));

      setData({
        ...details,
        seriesId,
        passingPercentage: 60,
        questions: cleanedQuestions,
      });
    }
  }, [details, quizId, seriesId]);

  const handleQuestionsChange = (updatedQuestions) => {
    setData((prev) => ({ ...prev, questions: updatedQuestions }));
  };

  const handleData = ({ target: { name, value } }) => {
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (label, date) => {
    setData((prev) => ({ ...prev, [label]: date }));
  };

  const handleSave = async () => {
    const check = validate(data);
    if (check) return;
    const { id, questionEditRemoveWarning, ...rest } = data;
    const payload = {
      ...rest,
      numberOfQuestions: parseInt(data?.numberOfQuestions, 10),
      questions: data?.questions,
    };

    try {
      dispatch(showProgress(true));
      const apiEndpoint = quizId === null ? apiEndpoints.QUIZ_CREATE : apiEndpoints.QUIZ_UPDATE?.replace('ID', quizId);
      await service.post(apiEndpoint, payload);
      notifySuccess('Quiz Added Successfully');
      fetchQuizSeriesList(seriesId, false);
      handleClose();
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <CustomPopupTopBar add={quizId === null} title="Quiz" close={handleClose} />
        <Grid container direction="column" className={classes.contentContainer}>
          <Grid item>
            <SingleSelectAdd
              data={data}
              setData={setData}
              handleData={handleData}
              handleDateChange={handleDateChange}
              handleQuestionsChange={handleQuestionsChange}
            />
          </Grid>
        </Grid>
        <div className={classes.buttonContainer}>
          <CustomPopupFooter add={!quizId} onClose={handleClose} saveContest={handleSave} step={1} totalSteps={1} />
        </div>
        <ShowProgress />
      </Box>
    </Modal>
  );
};

export default AddQuiz;
